/** Client-side hashing for signature unlock password / pattern. */

export async function sha256Hex(value: string): Promise<string> {
  const data = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return [...new Uint8Array(digest)]
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function hashUnlockPassword(password: string): Promise<string> {
  return sha256Hex(`nevisign-unlock-v1:${password}`);
}

export async function hashPattern(dots: number[]): Promise<string> {
  return sha256Hex(`nevisign-pattern-v1:${dots.join("-")}`);
}
